/**
 * Afslut & fakturér is one action. It is offered while the visit is still
 * open. Paying in advance does not hide it: finish still stamps completed_at
 * and reuses the invoice.
 */
export function canFinishAndInvoice(input: {
  status: string | null | undefined;
  hasPatient: boolean;
  canCreateInvoices: boolean;
}): boolean {
  if (!input.canCreateInvoices || !input.hasPatient) return false;
  switch (input.status) {
    case 'upcoming':
      return true;
    case 'completed':
    case 'cancelled':
    case 'no_show':
      return false;
    default:
      return false;
  }
}

export function finishAndInvoiceLabelKey(): string {
  return 'appointments.finish.action';
}

export type FinishOutcome = 'issued' | 'already_covered' | 'difference' | 'punch_card_pending';

export function finishToastKey(outcome: FinishOutcome): string {
  switch (outcome) {
    case 'issued':
      return 'appointments.finish.done_issued';
    case 'already_covered':
      return 'appointments.finish.done_covered';
    case 'difference':
      return 'appointments.finish.done_difference';
    case 'punch_card_pending':
      return 'appointments.finish.done_punch';
    default: {
      const _exhaustive: never = outcome;
      return _exhaustive;
    }
  }
}
